import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';

export function formatTimeSinceAdmission(
  admissionDate: string,
  format: 'short' | 'long' = 'short',
): string {
  dayjs.extend(duration);
  dayjs.extend(customParseFormat);
  const start = dayjs(admissionDate);
  const end = dayjs();

  const years = end.diff(start, 'year');
  const dateAfterYears = start.add(years, 'year');

  const months = end.diff(dateAfterYears, 'month');
  const dateAfterMonths = dateAfterYears.add(months, 'month');

  const days = end.diff(dateAfterMonths, 'day');

  const isShort = format === 'short';

  const parts: string[] = [];
  const yearsText = isShort ? 'a' : years > 1 ? ' anos' : ' ano';
  const monthsText = isShort ? 'm' : months > 1 ? ' meses' : ' mês';
  const daysText = isShort ? 'd' : days > 1 ? ' dias' : ' dia';

  if (years > 0) parts.push(`${years}${yearsText}`);
  if (months > 0) parts.push(`${months}${monthsText}`);
  if (days > 0) parts.push(`${days}${daysText}`);

  return parts.length > 0 ? parts.join(' ') : '0d';
}
